import { ApolloQueryResult } from '@apollo/client/core/types';
import { useSidebar } from '@css-xp/base';
import { BillingAdmin, CommerceAddress } from '@css-xp/graphtypes';
import React from 'react';
import EditBillingDetailsForm from './edit-billing-details-form';

/**
 * This component is required to pass closeSidebar to the form. calling useSidebar
 * directly on the calling page causes continuous re-rendering
 * */

export interface EditBillingDetails {
  transactionAccountId?: string;
  billToAddress?: CommerceAddress | null;
  shipToAddress?: CommerceAddress | null;
  displayName?: string | null;
  invoiceGroupId?: string;
  billToPartyPricingEligibilty?: string | null;
  billingAdmins?: (BillingAdmin | undefined | null)[];
  isShipToAddressViewable?: boolean | true;
  onComplete: () => Promise<ApolloQueryResult<unknown>>;
}
export const EditBillingDetailsSidebar = ({ ...props }: EditBillingDetails) => {
  const { closeSidebar, reopenMostRecentSidebar } = useSidebar();

  const onEditTransactionAccountComplete = async () => {
    await props.onComplete();
    reopenMostRecentSidebar({
      payload: {
        ...props,
      },
    });
  };
  return (
    <div>
      <EditBillingDetailsForm
        {...props}
        isShipToAddressViewable={false}
        onComplete={onEditTransactionAccountComplete}
        onClose={closeSidebar}
      />
    </div>
  );
};
